import axios from "axios";
import Cookies from "universal-cookie";

require('dotenv').config()

const cookies = new Cookies();

axios.defaults.withCredentials = true

class Auth {
    constructor() {
        this.authenticated = "false"
    }
    isAuthenticated() {
        const accessToken = cookies.get('authSession')
        const refreshToken = cookies.get('refreshTokenID')

        if (!window.localStorage.getItem('MobileLogin')) {
            axios.get(`${process.env.REACT_APP_BACKEND_API}/logout`).then((res) => {
                console.log(res.data)

            }).catch((error) => {
                console.error(error.response)
            })
            this.authenticated = "false"

        }

        if (!accessToken && !refreshToken) {
            this.authenticated = "false"
        }
        if (accessToken && refreshToken) {
            this.authenticated = "true";
        }
        if (!accessToken && refreshToken) {
            this.authenticated = "pending"
            axios.post(`${process.env.REACT_APP_BACKEND_API}/refresh`, {
                withCredentials: true
            }).then((res) => {
                console.log(res.data)
                this.authenticated = "true";
            }).catch((error) => {
                console.log(error.response)
                this.authenticated = "false"
            })
        }
    }
}

export default new Auth()